export const AVAILABLE_CURRENCY_CODES = {
  USD: 'USD',
  EUR: 'EUR',
  GBP: 'GBP',
  AUD: 'AUD',
  JPY: 'JPY',
  SGD: 'SGD',
  COP: 'COP',
  CAD: 'CAD',
  INR: 'INR'
};